import { CardImage, Content, CardContent, CardContainer } from "./Card.styled";
import Stack from "../Utils/Stack.styled";
import Paragraph from "../Utils/Paragraph.styled";
import Title from "../Utils/Title.styled";
import { motion } from "framer-motion";
import { useState } from "react";
import MiniVideo from "../MiniVideo";
import PropTypes from "prop-types";
// import Icon from "../Icon/Icon";
// import CONSTANT from "../../constants/constant";
// import Box from "../Utils/Box.styled";
// import Button from "../Button";

const Card = ({
  image,
  id,
  title,
  duration,
  views,
  channel,
  onClick,
  grid,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [scaleCard, setScaleCard] = useState(1);
  // const [showMoreOption, setShowMoreOption] = useState(false);
  let timeout;

  const reset = () => {
    clearTimeout(timeout);
    setIsVisible(false);
    setScaleCard(1);
  };

  const onCountingMode = () => {
    if (grid) {
      timeout = setTimeout(() => {
        setIsVisible(true);
        setScaleCard(1.2);
      }, 2000);
    }
  };

  const ContentDetail = ({ isMiniVideo }) => {
    return (
      <Stack
        direction="column"
        gap={isMiniVideo ? "8" : "10"}
        onClick={onClickDetails}
      >
        <div>
          <Title
            overflow={1}
            size={isMiniVideo ? "14px" : "14px"}
            height={isMiniVideo ? "100%" : "33px"}
          >
            {title}
          </Title>
        </div>

        <Stack justifyContent="space-between" alignItems="end">
          <Paragraph size={isMiniVideo ? "10px" : "12px"}>{channel}</Paragraph>
          <Paragraph size={isMiniVideo ? "10px" : "12px"}>
            {Number(views).toLocaleString()} Views
          </Paragraph>
        </Stack>
      </Stack>
    );
  };

  const onClickDetails = () => {
    if (isVisible) {
      onClick();
    }
  };

  const onClickCard = () => {
    if (!isVisible) {
      onClick();
    } else {
      setScaleCard(1);
      setIsVisible(false);
    }
  };

  return (
    <CardContainer
      as={motion.div}
      whileHover={{ scale: grid ? scaleCard : 1, zIndex: 20 }}
      transition={{ duration: 0.5 }}
      grid={grid}
      onMouseEnter={() => onCountingMode()}
      onMouseLeave={() => reset()}
    >
      <Stack
        onClick={onClickCard}
        direction={grid ? "column" : "row"}
        justifyContent="start"
        alignItems="start"
      >
        <CardImage img={image} grid={grid}>
          <Stack direction="column" justifyContent="end">
            <Stack
              justifyContent="space-between"
              alignItems="end"
              padding="0px"
              height="35px"
            >
              <CardContent></CardContent>
              <Paragraph
                size={grid ? "12px" : "10px"}
                style={{
                  background: "black",
                  padding: "8px",
                  borderRadius: "4px",
                  color: "white",
                }}
              >
                {duration}
              </Paragraph>
            </Stack>
          </Stack>
        </CardImage>
        <Content grid={grid}>
          <ContentDetail />
        </Content>
      </Stack>
      {/* {!grid && (
        <motion.div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: "10",
          }}
          onClick={() => setShowMoreOption(!showMoreOption)}
        >
          <Icon size="20px" type={CONSTANT.ICON.DOT} />
        </motion.div>
      )}
      {showMoreOption && (
        <Box
          style={{
            position: "absolute",
            borderRadius: "8px",
            zIndex: "10",
            top: 24,
            right: 0,
            width: "fit-content",
            background: "transparent",
          }}
        >
      <Stack direction="column">
            <Button
              padding="8px"
              label="Add to queue"
              type={CONSTANT.ICON.ADD_TO_QUEUE}
            />
            <Button
              padding="8px"
              label="Add to playlist"
              type={CONSTANT.ICON.ADD_TO_PLAYLIST}
            />
          </Stack>
      </Box>
      )} */}
      {isVisible && grid && (
        <MiniVideo
          key={"miniVideo_" + id}
          title={title}
          videoId={id}
          thumbnailUrl={image}
        >
          <ContentDetail isMiniVideo />
        </MiniVideo>
      )}
    </CardContainer>
  );
};

Card.propTypes = {
  grid: PropTypes.number,
};

export default Card;
